import React from "react";
import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";
import { Star } from "lucide-react";

export default function Hero({ brand, stats, onBook }) {
  return (
    <section className="relative">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10 pt-10 md:pt-20 pb-8 md:pb-16">
        <motion.h1
          initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
          className="font-serif-ev text-[3.1rem] leading-[1.02] tracking-tight sm:text-6xl md:text-[5.5rem] md:leading-[0.98] max-w-[900px]"
          style={{ color: "var(--ev-ink)" }}
        >
          Live Healing & Manifestation{" "}
          <span className="italic" style={{ color: "var(--ev-blue-2)", fontWeight: 400 }}>Coaching</span>
          <span className="block mt-3 font-serif-ev text-3xl sm:text-4xl md:text-5xl" style={{ color: "var(--ev-ink-2)" }}>
            with {brand?.coach || "Prriyanka Dora"}
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-6 text-[15px] md:text-lg max-w-xl"
          style={{ color: "var(--ev-muted)" }}
        >
          {brand?.hero_subtitle || "1-on-1 & group sessions — available worldwide, live over Zoom."}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.15 }}
          className="mt-8 flex flex-col items-start gap-3"
        >
          <button
            data-testid={HOME.heroBookBtn}
            onClick={onBook}
            className="ev-btn ev-btn-primary w-full sm:w-auto"
          >
            Book a free session
          </button>
          <div className="text-sm" style={{ color: "var(--ev-muted)" }}>No credit card required</div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.3 }}
          className="mt-6 flex items-center gap-3"
        >
          <div className="flex" style={{ color: "var(--ev-blue-2)" }}>
            {[0,1,2,3,4].map((i) => (<Star key={i} className="w-5 h-5 fill-current" />))}
          </div>
          <span className="text-sm" style={{ color: "var(--ev-ink-2)" }}>
            <span className="font-semibold">{stats?.rating || "4.9"}</span>{" · "}{stats?.reviews_count || "2,000+"} five-star reviews
          </span>
        </motion.div>
      </div>

      <div className="mx-auto max-w-[1200px] px-5 md:px-10 pb-16">
        <motion.div
          initial={{ opacity: 0, scale: 1.02 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1 }}
          className="relative rounded-[24px] overflow-hidden"
          style={{ aspectRatio: "4/3" }}
        >
          <img
            src={brand?.hero_image || "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1600&q=80"}
            alt="Sunrise over calm ocean"
            className="w-full h-full object-cover"
          />
          <div className="absolute left-4 bottom-4 md:left-6 md:bottom-6">
            <div className="ev-pill flex-col items-start !py-3 !px-4">
              <span className="eyebrow !text-[10px]">Sessions guided</span>
              <span className="font-serif-ev text-2xl md:text-3xl" style={{ color: "var(--ev-blue-2)" }}>
                {stats?.sessions_guided || "4,000+"}
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
